import { NgModule } from '@angular/core';
import { LazyLoadItemDirective } from './lazy-load-item.directive';
import { LazyLoadDirective } from './lazy-load';

@NgModule({
  declarations: [
    LazyLoadItemDirective,
    LazyLoadDirective
  ],
  exports:[
    LazyLoadItemDirective,
    LazyLoadDirective
  ]
})
export class LazyLoadModule { }
